import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "layout"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import theme from '../theme.config';
import { domProps, responsiveProps } from '../../utils';
var descendants = '& > *';
var generateColumns = function generateColumns(length) {
  return Array.from({
    length: length
  }).map(function (_next, i) {
    var numOfCols = i + 1;
    return {
      layout: 'tile',
      columns: numOfCols,
      css: _defineProperty({}, descendants, {
        flexBasis: numOfCols === 1 ? '100%' : "calc(100% / ".concat(numOfCols, " - $layout-gap / calc(").concat(numOfCols, " / ").concat(i, "))")
      })
    };
  });
};
var box = theme.css({
  display: 'flex'
});
var styles = theme.css({
  display: 'flex',
  gap: '$layout-gap',
  flexGrow: 1,
  alignItems: 'center',
  variants: {
    layout: {
      basic: {
        justifyContent: 'flex-start'
      },
      right: {
        justifyContent: 'flex-end'
      },
      equal: _defineProperty({}, descendants, {
        flexBasis: 0,
        flexGrow: 1
      }),
      split: {
        justifyContent: 'space-between'
      },
      stack: {
        alignItems: 'stretch',
        flexDirection: 'column',
        width: '$full'
      },
      tile: _defineProperty({
        flexWrap: 'wrap',
        alignItems: 'stretch',
        flexBasis: 0
      }, descendants, {
        flexGrow: 0
      }),
      cluster: {
        flexWrap: 'wrap'
      }
    },
    alignY: {
      top: {
        alignItems: 'flex-start'
      },
      center: {
        alignItems: 'center'
      },
      bottom: {
        alignItems: 'flex-end'
      },
      stretch: {
        alignItems: 'stretch'
      }
    },
    alignX: {
      left: {},
      center: {},
      right: {},
      stretch: {}
    },
    columns: {}
  },
  compoundVariants: [{
    layout: 'basic',
    css: {
      justifyContent: 'flex-start'
    }
  }, {
    layout: 'right',
    css: {
      justifyContent: 'flex-end'
    }
  }, {
    layout: 'equal',
    css: {
      justifyContent: 'normal'
    }
  }, {
    layout: 'split',
    css: {
      justifyContent: 'space-between'
    }
  }, {
    layout: 'tile',
    css: {
      justifyContent: 'normal'
    }
  }, {
    layout: 'stack',
    alignX: 'left',
    css: {
      alignItems: 'flex-start'
    }
  }, {
    layout: 'stack',
    alignX: 'center',
    css: {
      alignItems: 'center'
    }
  }, {
    layout: 'stack',
    alignX: 'right',
    css: {
      alignItems: 'flex-end'
    }
  }, {
    layout: 'stack',
    alignX: 'stretch',
    css: {
      alignItems: 'stretch'
    }
  }, {
    layout: 'cluster',
    alignX: 'left',
    css: {
      justifyContent: 'flex-start'
    }
  }, {
    layout: 'cluster',
    alignX: 'center',
    css: {
      justifyContent: 'center'
    }
  }, {
    layout: 'cluster',
    alignX: 'right',
    css: {
      justifyContent: 'flex-end'
    }
  }].concat(_toConsumableArray(generateColumns(32)))
});
var EzLayout = function EzLayout(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'basic' : _ref$layout,
    initialProps = _objectWithoutProperties(_ref, _excluded);
  var props = responsiveProps(_objectSpread(_objectSpread({}, initialProps), {}, {
    layout: layout
  }), true, 'layout', 'alignX', 'alignY', 'columns');
  return React.createElement("div", domProps(_objectSpread(_objectSpread({}, props), {}, {
    className: className
  }), box()), React.createElement("div", {
    className: styles(props)
  }, children));
};
export default EzLayout;